import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../constants/data';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    backgroundColor: '#0F0F0F'
  }} data-id="element-115">
      <div className="mx-auto max-w-3xl" data-id="element-116">
        <Reveal data-id="element-117">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold" data-id="element-118">
            ❓ Preguntas Frecuentes
          </h2>
        </Reveal>

        <div className="mt-10 space-y-3" data-id="element-119">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="rounded-xl border transition-colors" style={{
            borderColor: isOpen ? 'transparent' : 'rgba(255,255,255,0.08)',
            borderLeft: isOpen ? '3px solid #00C853' : '1px solid rgba(255,255,255,0.08)',
            backgroundColor: isOpen ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.02)'
          }} data-id="element-120">
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-121">
                  <span className="font-medium text-white text-sm sm:text-base" data-id="element-122">
                    {faq.q}
                  </span>
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="shrink-0" style={{
                color: isOpen ? '#00C853' : 'rgba(255,255,255,0.5)'
              }} data-id="element-123">
                    <PlusIcon className="w-5 h-5" aria-hidden="true" data-id="element-124" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false} data-id="element-125">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-126">
                      <p className="px-5 pb-4 text-sm text-white/70 leading-relaxed" data-id="element-127">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}